"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_lite_1 = require("mobx-react-lite");
var query_string_1 = __importDefault(require("query-string"));
var api_1 = __importDefault(require("api"));
var use_stores_1 = require("hooks/use-stores");
var Title_1 = __importDefault(require("components/core/common/Title"));
var AccountBar_1 = __importDefault(require("components/core/common/AccountBar"));
var HomeTabs_1 = __importDefault(require("./HomeTabs"));
var HomeTable_1 = __importDefault(require("./HomeTable"));
var HomeUserFilter_1 = __importDefault(require("./HomeUserFilter"));
var HomeQueryTypeFilter_1 = __importDefault(require("./HomeQueryTypeFilter"));
var HomeCountryFilter_1 = __importDefault(require("./HomeCountryFilter"));
var navState_1 = require("../../../../contexts/navState");
var use_nav_state_1 = require("hooks/use-nav-state");
var HomeSearch_1 = __importDefault(require("./HomeSearch"));
var close_svg_1 = __importDefault(require("res/img/close.svg"));
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("components/core/Notification");
var HomeSort_1 = __importDefault(require("./HomeSort"));
var config_1 = __importDefault(require("config"));
var Pager_1 = __importDefault(require("./Pager"));
var utils_1 = require("../../../../util/utils");
var HomeCustomerSearch_1 = __importDefault(require("./HomeCustomerSearch"));
var CustomerAdd_1 = __importDefault(require("./CustomerAdd"));
var toBoolean = function (input) { return input === "true"; };
var QueryLogHome = mobx_react_lite_1.observer(function () {
    var _a = use_stores_1.useStores(), userStore = _a.userStore, queriesStore = _a.queriesStore, prefsStore = _a.prefsStore, authorisationsStore = _a.authorisationsStore, customersStore = _a.customersStore, usersStore = _a.usersStore, queryPageStore = _a.queryPageStore, customerPrefsStore = _a.customerPrefsStore, customerPageStore = _a.customerPageStore;
    var _b = react_1.useState(prefsStore.data.queryPrefs.activeTab), activeTab = _b[0], setActiveTab = _b[1];
    var _c = react_1.useState(prefsStore.data.queryPrefs.currentUserOnly), currentUserOnly = _c[0], setCurrentUserOnly = _c[1];
    var _d = react_1.useState(prefsStore.data.queryPrefs.currentQueryType), currentQueryType = _d[0], setCurrentQueryType = _d[1];
    var _e = react_1.useState(customerPrefsStore.data.queryPrefs.currentQueryType), currentCustomerQueryType = _e[0], setCurrentCustomerQueryType = _e[1];
    var _f = react_1.useState(prefsStore.data.queryPrefs.currentCountry), currentCountry = _f[0], setCurrentCountry = _f[1];
    var _g = react_1.useState(customerPrefsStore.data.queryPrefs.currentCountry), currentCustomerCountry = _g[0], setCurrentCustomerCountry = _g[1];
    var _h = react_1.useState(null), clearFlag = _h[0], setClearFlag = _h[1];
    var history = react_router_dom_1.useHistory();
    var location = react_router_dom_1.useLocation();
    var navState = use_nav_state_1.useNavState();
    var notification = use_notification_1.useNotification();
    var search = query_string_1.default.parse(location.search) || {};
    var _j = react_1.useState(false), busy = _j[0], setBusy = _j[1];
    var _k = react_1.useState(prefsStore.data.queryTable.page - 1), offset = _k[0], setOffset = _k[1];
    var _l = react_1.useState(customerPrefsStore.data.queryTable.page - 1), customerOffset = _l[0], setCustomerOffset = _l[1];
    var prefs = prefsStore.data.queryTable;
    var customerPrefs = customerPrefsStore.data.queryTable;
    navState.saveState(navState_1.NavState.COLLAPSED);
    react_1.useEffect(function () {
        //if (queriesStore.data.length <= 0) {
        getQueriesAPI(offset + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, activeTab, prefsStore.data.queryPrefs.searchType, prefsStore.data.queryPrefs.searchValue, prefsStore.data.queryPrefs.currentQueryType, prefsStore.data.queryPrefs.currentCountry, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
        //}
    }, []);
    if (userStore.isAdmin) {
        react_1.useEffect(function () {
            //if (queriesStore.data.length <= 0) {
            var busyTimeout = setTimeout(function () {
                setBusy(true);
            }, config_1.default.busyDelay);
            api_1.default.getAuthorisations()
                .then(function (response) {
                clearTimeout(busyTimeout);
                setBusy(false);
                authorisationsStore.setData(response.data);
            }, function (error) {
                clearTimeout(busyTimeout);
                setBusy(false);
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error fetching authorisations, please try refreshing the page"
                });
            })
                .catch(function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error fetching authorisations, please try refreshing the page"
                });
            });
            //}
            //if (queriesStore.data.length <= 0) {
            getCustomersAPI(customerOffset + 1, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
            //}
        }, []);
    }
    if (userStore.isAdmin) {
        react_1.useEffect(function () {
            //if (queriesStore.data.length <= 0) {
            var busyTimeout = setTimeout(function () {
                setBusy(true);
            }, config_1.default.busyDelay);
            api_1.default.getUsers()
                .then(function (response) {
                clearTimeout(busyTimeout);
                setBusy(false);
                usersStore.setData(response.data);
            }, function (error) {
                clearTimeout(busyTimeout);
                setBusy(false);
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error fetching users, please try refreshing the page"
                });
            })
                .catch(function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error fetching users, please try refreshing the page"
                });
            });
            //}
        }, []);
    }
    react_1.useEffect(function () {
        if (typeof search.recent !== "undefined") {
            setCurrentUserOnly(false);
            setTimeout(function () {
                history.replace("/");
            }, 2000);
        }
        var highlight = document.querySelector(".table__tr[data-id=\"" + search.recent + "\"]");
        if (highlight !== null) {
            var bounds = highlight.getBoundingClientRect();
            var scrollElement = document.querySelector('.root__routes');
            scrollElement.scroll({
                left: 0,
                top: bounds.y - window.innerHeight / 2,
                behavior: "smooth"
            });
        }
    }, [search]);
    var logoutHandler = function () {
        userStore.unsetData();
        history.replace("/login");
    };
    var changeHandler = function (e) {
        setActiveTab(e.currentTarget.dataset.tab);
        prefsStore.editData({
            queryPrefs: __assign(__assign({}, prefsStore.data.queryPrefs), { activeTab: e.currentTarget.dataset.tab })
        });
        if (e.currentTarget.dataset.tab !== 'Holiday' && e.currentTarget.dataset.tab !== 'Reports') {
            getQueriesAPI(offset + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, e.currentTarget.dataset.tab, prefsStore.data.queryPrefs.searchType, prefsStore.data.queryPrefs.searchValue, prefsStore.data.queryPrefs.currentQueryType, prefsStore.data.queryPrefs.currentCountry, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
        }
    };
    var userFilterHandler = function (e) {
        prefsStore.editData({
            queryPrefs: __assign(__assign({}, prefsStore.data.queryPrefs), { currentUserOnly: toBoolean(e.currentTarget.value) })
        });
        setCurrentUserOnly(toBoolean(e.currentTarget.value));
        console.log(e.currentTarget.value);
        getQueriesAPI(offset + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, activeTab, prefsStore.data.queryPrefs.searchType, prefsStore.data.queryPrefs.searchValue, prefsStore.data.queryPrefs.currentQueryType, prefsStore.data.queryPrefs.currentCountry, e.currentTarget.value);
    };
    var queryTypeFilterHandler = function (e) {
        prefsStore.editData({
            queryPrefs: __assign(__assign({}, prefsStore.data.queryPrefs), { currentQueryType: e.currentTarget.value })
        });
        setCurrentQueryType(e.currentTarget.value);
        getQueriesAPI(offset + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, activeTab, prefsStore.data.queryPrefs.searchType, prefsStore.data.queryPrefs.searchValue, e.currentTarget.value, prefsStore.data.queryPrefs.currentCountry, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
    };
    var customerQueryTypeFilterHandler = function (e) {
        customerPrefsStore.editData({
            queryPrefs: __assign(__assign({}, customerPrefsStore.data.queryPrefs), { currentQueryType: e.currentTarget.value })
        });
        setCurrentCustomerQueryType(e.currentTarget.value);
        getCustomersAPI(customerOffset + 1, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, e.currentTarget.value, customerPrefsStore.data.queryPrefs.currentCountry);
    };
    var countryFilterHandler = function (e) {
        prefsStore.editData({
            queryPrefs: __assign(__assign({}, prefsStore.data.queryPrefs), { currentCountry: e.currentTarget.value })
        });
        setCurrentCountry(e.currentTarget.value);
        getQueriesAPI(offset + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, activeTab, prefsStore.data.queryPrefs.searchType, prefsStore.data.queryPrefs.searchValue, prefsStore.data.queryPrefs.currentQueryType, e.currentTarget.value, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
    };
    var customerCountryFilterHandler = function (e) {
        customerPrefsStore.editData({
            queryPrefs: __assign(__assign({}, customerPrefsStore.data.queryPrefs), { currentCountry: e.currentTarget.value })
        });
        setCurrentCustomerCountry(e.currentTarget.value);
        getCustomersAPI(customerOffset + 1, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, customerPrefsStore.data.queryPrefs.currentQueryType, e.currentTarget.value);
    };
    var changeTypeHandler = function (e) {
        prefsStore.editData({
            queryPrefs: __assign(__assign({}, prefsStore.data.queryPrefs), { searchType: e.currentTarget.value })
        });
        getQueriesAPI(offset + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, activeTab, e.currentTarget.value, prefsStore.data.queryPrefs.searchValue, prefsStore.data.queryPrefs.currentQueryType, prefsStore.data.queryPrefs.currentCountry, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
    };
    var changeSearchValue = function (value) {
        prefsStore.editData({
            queryPrefs: __assign(__assign({}, prefsStore.data.queryPrefs), { searchValue: value })
        });
        getQueriesAPI(offset + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, activeTab, prefsStore.data.queryPrefs.searchType, value, prefsStore.data.queryPrefs.currentQueryType, prefsStore.data.queryPrefs.currentCountry, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
    };
    var clearSearch = function () {
        prefsStore.editData({
            queryPrefs: __assign(__assign({}, prefsStore.data.queryPrefs), { searchValue: "" })
        });
        setClearFlag(Date.now().toString());
        getQueriesAPI(offset + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, activeTab, prefsStore.data.queryPrefs.searchType, "", prefsStore.data.queryPrefs.currentQueryType, prefsStore.data.queryPrefs.currentCountry, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
    };
    var changeCustomerSearchValue = function (value) {
        customerPrefsStore.editData({
            queryPrefs: __assign(__assign({}, customerPrefsStore.data.queryPrefs), { searchValue: value })
        });
        getCustomersAPI(offset + 1, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, value, customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
    };
    var clearCustomerSearch = function () {
        customerPrefsStore.editData({
            queryPrefs: __assign(__assign({}, customerPrefsStore.data.queryPrefs), { searchValue: "" })
        });
        setClearFlag(Date.now().toString());
        getCustomersAPI(offset + 1, prefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, "", customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
    };
    var changeSortType = function (e) {
        prefsStore.editData({
            queryPrefs: __assign(__assign({}, prefsStore.data.queryPrefs), { sortTypeValue: e.currentTarget.value })
        });
        getQueriesAPI(offset + 1, prefs.perPage, e.currentTarget.value, activeTab, prefsStore.data.queryPrefs.searchType, prefsStore.data.queryPrefs.searchValue, prefsStore.data.queryPrefs.currentQueryType, prefsStore.data.queryPrefs.currentCountry, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
    };
    var saveRow = function (e) {
        e.preventDefault();
        var formData = new FormData(e.currentTarget);
        var submitter = e.nativeEvent.submitter;
        var authorisationId = Number(submitter.getAttribute("data-authorisation"));
        var command = submitter.value;
        var data = {
            alternativeUserId: formData.get('alternativeUserId'),
            startDate: formData.get('startDate'),
            endDate: formData.get('endDate'),
        };
        if (command === "delete") {
            var customerId = Number(submitter.getAttribute("data-customer"));
            var busyTimeout_1 = setTimeout(function () {
                setBusy(true);
            }, config_1.default.busyDelay);
            api_1.default.deleteCustomer(customerId)
                .then(function (response) {
                getCustomersAPI(customerPrefs.page, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Customer deleted"
                });
                clearTimeout(busyTimeout_1);
                setBusy(false);
            }, function (error) {
                clearTimeout(busyTimeout_1);
                setBusy(false);
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error deleting Customer"
                });
            })
                .catch(function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error deleting customer, please try refreshing the page"
                });
            });
        }
        else if (command === 'save') {
            var busyTimeout_2 = setTimeout(function () {
                setBusy(true);
            }, config_1.default.busyDelay);
            api_1.default.saveAuthorisation(authorisationId, data)
                .then(function (response) {
                api_1.default.getAuthorisations()
                    .then(function (response) {
                    clearTimeout(busyTimeout_2);
                    setBusy(false);
                    authorisationsStore.setData(response.data);
                }, function (error) {
                    clearTimeout(busyTimeout_2);
                    setBusy(false);
                    notification({
                        variant: Notification_1.NotificationVariants.ERROR,
                        message: "Error fetching authorisations, please try refreshing the page"
                    });
                })
                    .catch(function (error) {
                    notification({
                        variant: Notification_1.NotificationVariants.ERROR,
                        message: "Error fetching authorisations, please try refreshing the page"
                    });
                });
            }, function (error) {
                clearTimeout(busyTimeout_2);
                setBusy(false);
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error saving authorisation, please try refreshing the page"
                });
            })
                .catch(function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error saving authorisation, please try refreshing the page"
                });
            });
        }
        else {
            var busyTimeout_3 = setTimeout(function () {
                setBusy(true);
            }, config_1.default.busyDelay);
            api_1.default.clearAuthorisation(authorisationId)
                .then(function (response) {
                api_1.default.getAuthorisations()
                    .then(function (response) {
                    clearTimeout(busyTimeout_3);
                    setBusy(false);
                    authorisationsStore.setData(response.data);
                }, function (error) {
                    clearTimeout(busyTimeout_3);
                    setBusy(false);
                    notification({
                        variant: Notification_1.NotificationVariants.ERROR,
                        message: "Error fetching authorisations, please try refreshing the page"
                    });
                })
                    .catch(function (error) {
                    notification({
                        variant: Notification_1.NotificationVariants.ERROR,
                        message: "Error fetching authorisations, please try refreshing the page"
                    });
                });
            }, function (error) {
                clearTimeout(busyTimeout_3);
                setBusy(false);
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error saving authorisation, please try refreshing the page"
                });
            })
                .catch(function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Error saving authorisation, please try refreshing the page"
                });
            });
        }
    };
    var updateCustomer = function (e) {
        var _a;
        var busyTimeout2 = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        var value = e.currentTarget.value;
        var id = Number(e.currentTarget.getAttribute('data-customer'));
        api_1.default.patchCustomer(id, (_a = {},
            _a[e.currentTarget.name] = value,
            _a))
            .then(function (response) {
            getCustomersAPI(customerPrefs.page, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Customer updated"
            });
            clearTimeout(busyTimeout2);
            setBusy(false);
        }, function (error) {
            clearTimeout(busyTimeout2);
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating Customer"
            });
        });
    };
    var timeoutRef = react_1.useRef(null);
    var updateCustomerText = function (e) {
        var busyTimeout2 = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        clearTimeout(timeoutRef.current);
        var value = e.currentTarget.value;
        var id = Number(e.currentTarget.getAttribute('data-customer'));
        timeoutRef.current = setTimeout(function () { return api_1.default.patchCustomer(id, {
            'name': value
        })
            .then(function (response) {
            getCustomersAPI(customerPrefs.page, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Customer updated"
            });
            clearTimeout(busyTimeout2);
            setBusy(false);
        }, function (error) {
            clearTimeout(busyTimeout2);
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating Customer"
            });
        }); }, 1500);
    };
    var customerAddSubmit = function (e) {
        e.preventDefault();
        var formData = new FormData(e.currentTarget);
        var data = {};
        formData.forEach(function (value, key) {
            data[key] = value;
        });
        var busyTimeout2 = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        api_1.default.addCustomer(data)
            .then(function (response) {
            getCustomersAPI(customerPrefs.page, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Customer added"
            });
            clearTimeout(busyTimeout2);
            setBusy(false);
        }, function (error) {
            clearTimeout(busyTimeout2);
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error adding Customer"
            });
        });
    };
    var customerUpload = function (files) {
        if (!files || files.length === 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please select a file."
            });
            return;
        }
        var busyTimeout2 = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        var formData = new FormData();
        formData.append("dataFile", files[0]);
        api_1.default.uploadCustomers(formData)
            .then(function (response) {
            getCustomersAPI(customerPrefs.page, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Customers added"
            });
            clearTimeout(busyTimeout2);
            setBusy(false);
        }, function (error) {
            clearTimeout(busyTimeout2);
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error uploading Customers. Please check file format and structure"
            });
        });
    };
    var pageHandler = function (page) {
        var max = Math.ceil((queryPageStore.data === undefined ? prefsStore.data.queryTable.results : queryPageStore.data.results) / prefs.perPage) - 1;
        if (page === offset)
            return;
        if (offset === max && page >= max)
            return;
        if (offset === 0 && page <= 0)
            return;
        setOffset(utils_1.clamp(0, page, max));
        prefsStore.editData({
            queryTable: __assign(__assign({}, prefs), { page: page + 1 })
        });
        getQueriesAPI(page + 1, prefs.perPage, prefsStore.data.queryPrefs.sortTypeValue, activeTab, prefsStore.data.queryPrefs.searchType, prefsStore.data.queryPrefs.searchValue, prefsStore.data.queryPrefs.currentQueryType, prefsStore.data.queryPrefs.currentCountry, prefsStore.data.queryPrefs.currentUserOnly === true ? 'true' : 'false');
    };
    var customerPageHandler = function (page) {
        var max = Math.ceil((customerPageStore.data === undefined ? customerPrefsStore.data.queryTable.results : customerPageStore.data.results) / customerPrefs.perPage) - 1;
        if (page === customerOffset)
            return;
        if (customerOffset === max && page >= max)
            return;
        if (customerOffset === 0 && page <= 0)
            return;
        setCustomerOffset(utils_1.clamp(0, page, max));
        customerPrefsStore.editData({
            queryTable: __assign(__assign({}, prefs), { page: page + 1 })
        });
        getCustomersAPI(page + 1, customerPrefs.perPage, customerPrefsStore.data.queryPrefs.sortTypeValue, customerPrefsStore.data.queryPrefs.searchValue, customerPrefsStore.data.queryPrefs.currentQueryType, customerPrefsStore.data.queryPrefs.currentCountry);
    };
    var getQueriesAPI = function (pageNumber, perPage, sort, active, searchType, searchValue, queryType, country, myQueries) {
        var busyTimeout = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        api_1.default.getQueries(pageNumber, perPage, sort, active, searchType, searchValue, queryType !== "All Query Types" ? queryType : '', country !== "All Countries" ? country : '', myQueries !== "false" ? 'true' : '')
            .then(function (response) {
            clearTimeout(busyTimeout);
            setBusy(false);
            queriesStore.setData(response.data.data);
            queryPageStore.setData(response.data.pagination);
            var max = Math.ceil((queryPageStore.data === undefined ? prefsStore.data.queryTable.results : queryPageStore.data.results) / prefs.perPage) - 1;
            if (max < 0) {
                max = 0;
            }
            if (offset > max) {
                setOffset(max);
                prefsStore.editData({
                    queryTable: __assign(__assign({}, prefs), { page: max + 1 })
                });
            }
        }, function (error) {
            clearTimeout(busyTimeout);
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error fetching queries, please try refreshing the page"
            });
        })
            .catch(function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error fetching queries, please try refreshing the page"
            });
        });
    };
    var getCustomersAPI = function (pageNumber, perPage, sort, searchValue, queryType, country) {
        var busyTimeout2 = setTimeout(function () {
            setBusy(true);
        }, config_1.default.busyDelay);
        console.log(pageNumber, perPage, sort, searchValue, country);
        api_1.default.getCustomersPaged(pageNumber, perPage, sort, searchValue, queryType !== "All Query Types" ? queryType : '', country !== "All Countries" ? country : '')
            .then(function (response) {
            clearTimeout(busyTimeout2);
            setBusy(false);
            customersStore.setData(response.data.data);
            customerPageStore.setData(response.data.pagination);
            var max = Math.ceil((customerPageStore.data === undefined ? customerPrefsStore.data.queryTable.results : customerPageStore.data.results) / customerPrefs.perPage) - 1;
            if (max < 0) {
                max = 0;
            }
            if (customerOffset > max) {
                setCustomerOffset(max);
                prefsStore.editData({
                    queryTable: __assign(__assign({}, prefs), { page: max + 1 })
                });
            }
        }, function (error) {
            clearTimeout(busyTimeout2);
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error fetching customers, please try refreshing the page"
            });
        })
            .catch(function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error fetching customers, please try refreshing the page"
            });
        });
        //}
    };
    return (react_1.default.createElement("div", { className: "page query-log-home flex flex-column" },
        react_1.default.createElement(Title_1.default, null, "Query Log"),
        react_1.default.createElement(AccountBar_1.default, { user: userStore.data, logout: logoutHandler }),
        react_1.default.createElement(HomeTabs_1.default, { active: activeTab, onChange: changeHandler }),
        activeTab !== 'Reports' && activeTab !== 'Holiday' && activeTab !== 'Customer' ?
            react_1.default.createElement("div", { className: "filters flex flex-row", "data-active": prefsStore.data.queryPrefs.searchValue.length >= 1 },
                react_1.default.createElement(HomeSort_1.default, { onChange: changeSortType, sortType: prefsStore.data.queryPrefs.sortTypeValue }),
                react_1.default.createElement(HomeUserFilter_1.default, { currentUserOnly: currentUserOnly, onChange: userFilterHandler }),
                react_1.default.createElement(HomeQueryTypeFilter_1.default, { currentQueryType: currentQueryType, onChange: queryTypeFilterHandler }),
                react_1.default.createElement(HomeCountryFilter_1.default, { currentCountry: currentCountry, onChange: countryFilterHandler }),
                react_1.default.createElement(HomeSearch_1.default, { searchType: prefsStore.data.queryPrefs.searchType, onChangeType: changeTypeHandler, initValue: prefsStore.data.queryPrefs.searchValue, onChangeSearch: changeSearchValue, clearFlag: clearFlag }),
                react_1.default.createElement("button", { type: "button", title: "Clear Filters", onClick: clearSearch },
                    react_1.default.createElement("img", { src: close_svg_1.default, alt: "Clear Filters" }))) : activeTab === 'Customer' ?
            react_1.default.createElement("div", { className: "filters flex flex-row", "data-active": customerPrefsStore.data.queryPrefs.searchValue.length >= 1 },
                react_1.default.createElement(HomeQueryTypeFilter_1.default, { currentQueryType: currentCustomerQueryType, onChange: customerQueryTypeFilterHandler }),
                react_1.default.createElement(HomeCountryFilter_1.default, { currentCountry: currentCustomerCountry, onChange: customerCountryFilterHandler }),
                react_1.default.createElement(HomeCustomerSearch_1.default, { initValue: customerPrefsStore.data.queryPrefs.searchValue, onChangeSearch: changeCustomerSearchValue, clearFlag: clearFlag }),
                react_1.default.createElement("button", { type: "button", title: "Clear Filters", onClick: clearCustomerSearch },
                    react_1.default.createElement("img", { src: close_svg_1.default, alt: "Clear Filters" }))) : null,
        activeTab !== 'Reports' && activeTab !== 'Holiday' && activeTab !== 'Customer' ?
            react_1.default.createElement(Pager_1.default, { itemsLength: queryPageStore.data === undefined ? prefsStore.data.queryTable.results : queryPageStore.data.results, offset: offset, perPage: prefs.perPage, onPrev: function () { return pageHandler(offset - 1); }, onNext: function () { return pageHandler(offset + 1); }, onPage: pageHandler, busy: busy }) : activeTab === 'Customer' ?
            react_1.default.createElement(Pager_1.default, { itemsLength: customerPageStore.data === undefined ? customerPrefsStore.data.queryTable.results : customerPageStore.data.results, offset: customerOffset, perPage: customerPrefs.perPage, onPrev: function () { return customerPageHandler(customerOffset - 1); }, onNext: function () { return customerPageHandler(customerOffset + 1); }, onPage: customerPageHandler, busy: busy }) : null,
        activeTab === 'Customer' ?
            react_1.default.createElement(CustomerAdd_1.default, { submitHandler: customerAddSubmit, uploadHandler: customerUpload })
            : null,
        react_1.default.createElement(HomeTable_1.default, { data: queriesStore.data, authorisations: authorisationsStore.data, customers: customersStore.data, users: usersStore.data, activeTab: activeTab, user: userStore.data, recent: typeof search.recent !== "undefined" ? parseInt(search.recent.toString()) : null, userStore: userStore, busy: busy, submitHandler: saveRow, customerHandler: updateCustomer, customerTextHandler: updateCustomerText }),
        activeTab !== 'Reports' && activeTab !== 'Holiday' && activeTab !== 'Customer' ?
            react_1.default.createElement(Pager_1.default, { itemsLength: queryPageStore.data === undefined ? prefsStore.data.queryTable.results : queryPageStore.data.results, offset: offset, perPage: prefs.perPage, onPrev: function () { return pageHandler(offset - 1); }, onNext: function () { return pageHandler(offset + 1); }, onPage: pageHandler, busy: busy }) : activeTab === 'Customer' ?
            react_1.default.createElement(Pager_1.default, { itemsLength: customerPageStore.data === undefined ? customerPrefsStore.data.queryTable.results : customerPageStore.data.results, offset: customerOffset, perPage: customerPrefs.perPage, onPrev: function () { return customerPageHandler(customerOffset - 1); }, onNext: function () { return customerPageHandler(customerOffset + 1); }, onPage: customerPageHandler, busy: busy }) : null));
});
exports.default = QueryLogHome;
